const buildConfig = require('../buildSettings.json');

export const impersonateAndNavigateToFrankieProper = (employeeId:string,target: string = '_self') => {
    window.open(`${buildConfig.FRANKLIN_ST_V2_URL}/v2/admin/impersonate/${employeeId}`, target);
}